import { render, staticRenderFns } from "./favorites-btn.vue?vue&type=template&id=e2c4b120&"
import script from "./favorites-btn.vue?vue&type=script&lang=js&"
export * from "./favorites-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports